function convertStringToEnglishLetters(source) {
  const keyboardLayoutRussian = {
    й: "q",
    ц: "w",
    у: "e",
    к: "r",
    е: "t",
    н: "y",
    г: "u",
    ш: "i",
    щ: "o",
    з: "p",
    х: "[",
    ъ: "]",
    ф: "a",
    ы: "s",
    в: "d",
    а: "f",
    п: "g",
    р: "h",
    о: "j",
    л: "k",
    д: "l",
    ж: ";",
    э: "'",
    я: "z",
    ч: "x",
    с: "c",
    м: "v",
    и: "b",
    т: "n",
    ь: "m",
    б: ",",
    ю: ".",
    ".": "/",
  };

  // Convert to lower case
  const lowerCaseSource = source.toLowerCase();

  // Convert russian symbols inside the string to the english equivalent
  // help to get correct coins if user typed on russian keyboard by mistake
  return lowerCaseSource
    .split("")
    .map((char) => {
      return keyboardLayoutRussian[char] || char;
    })
    .join("");
}

export { convertStringToEnglishLetters };
